<div class="container" style="min-height: 80vh;">
	<div class="row">
		<div class="row py-2">
			<div class="col-5 p-0">
				<button
					class="btn newConv theme-blue-background-color text-white"
					(click)="newConversation()"
				>
					<i class="bi bi-plus-lg" aria-hidden="true"></i>
					&nbsp;
					<i class="bi bi-chat-fill" aria-hidden="true"></i>
				</button>
			</div>

			<label class="col-7 form-label theme-main-color fs-4 text-start">
				Conversations
			</label>
		</div>
		<input
			type="text"
			class="form-control"
			placeholder="Recherche"
			[(ngModel)]="searchedName"
		/>
	</div>
	<div class="row py-4 scroll">
		<div
			*ngFor="let userOfList of userList | filterUsersByEmployeeName: searchedName"
			(click)="emitReceiver(userOfList)"
			role="button"
		>
			<div
				*ngIf="userOfList.id !== currentUser?.id"
				class="d-flex justify-content-center border-bottom ps-2 py-3 hoverEmployee"
			>
				<div>
					<span class="me-2">{{ userOfList.employee?.firstName }}</span>
					<span class="me-2">{{ userOfList.employee?.lastName }}</span>
					<span
						class="text-white notification rounded-circle theme-green-background-color text-center"
						*ngIf="getNotificationNumberByIdSender(userOfList.id) > 0"
					>
						{{ getNotificationNumberByIdSender(userOfList.id) }}
					</span>
				</div>
			</div>
		</div>
	</div>
</div>
